import { AdapterFrontSvgData } from './AdapterFrontMarker';
import { AdapterSideSvgData } from './AdapterSideMarker';
import { AirplaneSvgData } from './AirplaneMarker';
import { BeehiveSvgData } from './BeehiveMarker';
import { BicycleSvgData } from './BicycleMarker';
import { BoomLiftSvgData } from './BoomLiftMaker';
import { BusSvgData } from './BusMarker';
import { CarSvgData } from './CarMarker';
import { ConcreteMixerSvgData } from './ConcreteMixerMarker.tsx';
import { ContainerSvgData } from './ContainerMarker.tsx';
import { DogSvgData } from './DogMarker.tsx';
import { DropDeckTrailerSvgData } from './DropDeckTrailerMarker.tsx';
import { DumperSvgData } from './DumperMarker.tsx';
import { ExcavatorTracksSvgData } from './ExcavatorTracksMarker';
import { ExcavatorWheelsSvgData } from './ExcavatorWheelsMarker';
import { ForkliftSvgData } from './ForkliftMarker';
import { GarbageTruckSvgData } from './GarbageTruckMarker';
import { GeneratorSvgData } from './GeneratorMarker';
import { MachinerySvgData } from './MachineryMarker';
import { MicrobusSvgData } from './MicrobusMarker';
import { MotorbikeSvgData } from './MotorbikeMarker';
import { OffroadSvgData } from './OffroadMarker';
import { PersonSvgData } from './PersonMarker';
import { QuadSvgData } from './QuadMarker';
import { RollerSvgData } from './RollerMarker';
import { SailboatSvgData } from './SailboatMarker.tsx';
import { ShipSvgData } from './ShipMarker';
import { StorehouseSvgData } from './StorehouseMarker';
import { TachoAvailableSvgData } from './TachoAvailableSvgData.tsx';
import { TachoDriveSvgData } from './TachoDriveSvgData.tsx';
import { TachoRestSvgData } from './TachoRestSvgData.tsx';
import { TachoWorkSvgData } from './TachoWorkMarker.tsx';
import { TankerSvgData } from './TankerMarker';
import { TractorSvgData } from './TractorMarker';
import { TrafficLightSvgData } from './TrafficLightMarker';
import { TrailerSvgData } from './TrailerMarker';
import { TrainSvgData } from './TrainMarker';
import { TruckLongSvgData } from './TruckLongMarker';
import { TruckSvgData } from './TruckMarker';

export function getMarkerDirection(directionDeg: number) {
  return `
  <div class="idata-target-marker-direction" style="transform: rotate(${-1 * directionDeg}deg);">
    <div class="idata-target-marker-direction-border"></div>
    <div class="idata-target-marker-direction-center"></div>
  </div>
  `;
}

export function getMarkerData(vehicleCategory: string, width: number, height: number, fillColor: string) {
  switch (vehicleCategory) {
    case 'adapterFront':
      return AdapterFrontSvgData(width, height, fillColor);
    case 'adapterSide':
      return AdapterSideSvgData(width, height, fillColor);
    case 'airplane':
      return AirplaneSvgData(width, height, fillColor);
    case 'beehive':
      return BeehiveSvgData(width, height, fillColor);
    case 'bicycle':
      return BicycleSvgData(width, height, fillColor);
    case 'boomLift':
      return BoomLiftSvgData(width, height, fillColor);
    case 'bus':
      return BusSvgData(width, height, fillColor);
    case 'concreteMixer':
      return ConcreteMixerSvgData(width, height, fillColor);
    case 'container':
      return ContainerSvgData(width, height, fillColor);
    case 'dropDeckTrailer':
      return DropDeckTrailerSvgData(width, height, fillColor);
    case 'dumper':
      return DumperSvgData(width, height, fillColor);
    case 'excavatorTracks':
      return ExcavatorTracksSvgData(width, height, fillColor);
    case 'excavatorWheels':
      return ExcavatorWheelsSvgData(width, height, fillColor);
    case 'forklift':
      return ForkliftSvgData(width, height, fillColor);
    case 'garbageTruck':
      return GarbageTruckSvgData(width, height, fillColor);
    case 'generator':
      return GeneratorSvgData(width, height, fillColor);
    case 'train':
      return TrainSvgData(width, height, fillColor);
    case 'machinery':
      return MachinerySvgData(width, height, fillColor);
    case 'microbus':
      return MicrobusSvgData(width, height, fillColor);
    case 'motorbike':
      return MotorbikeSvgData(width, height, fillColor);
    case 'offroad':
      return OffroadSvgData(width, height, fillColor);
    case 'person':
      return PersonSvgData(width, height, fillColor);
    case 'quad':
      return QuadSvgData(width, height, fillColor);
    case 'roller':
      return RollerSvgData(width, height, fillColor);
    case 'sailboat':
      return SailboatSvgData(width, height, fillColor);
    case 'ship':
      return ShipSvgData(width, height, fillColor);
    case 'storehouse':
      return StorehouseSvgData(width, height, fillColor);
    case 'tanker':
      return TankerSvgData(width, height, fillColor);
    case 'tractor':
      return TractorSvgData(width, height, fillColor);
    case 'trailer':
      return TrailerSvgData(width, height, fillColor);
    case 'trafficLight':
      return TrafficLightSvgData(width, height, fillColor);
    case 'truckLong':
      return TruckLongSvgData(width, height, fillColor);
    case 'truck':
      return TruckSvgData(width, height, fillColor);
    case 'car':
      return CarSvgData(width, height, fillColor);
    case 'dog':
      return DogSvgData(width, height, fillColor);
    case 'TACHO_WORK':
      return TachoWorkSvgData(width, height, fillColor);
    case 'TACHO_DRIVE':
      return TachoDriveSvgData(width, height, fillColor);
    case 'TACHO_AVAIL':
      return TachoAvailableSvgData(width, height, fillColor);
    case 'TACHO_REST':
      return TachoRestSvgData(width, height, fillColor);
    default:
      return CarSvgData(width, height, fillColor);
  }
}
